/**
 * ChevronForwardIcon — sanitized from `assets/newSvg/chevron-forward.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function ChevronForwardIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M16.0607,10.9393 C16.6465,11.5251 16.6465,12.4749 16.0607,13.0607 L10.4038,18.7175 C9.81804,19.3033 8.86829,19.3033 8.2825,18.7175 C7.69672,18.1317 7.69672,17.182 8.2825,16.5962 L12.8787,12 L8.2825,7.40381 C7.69672,6.81802 7.69672,5.86827 8.2825,5.28248 C8.86829,4.6967 9.81804,4.6967 10.4038,5.28249 L16.0607,10.9393 Z"
        fill={color}
      />
    </Svg>
  );
}

export default ChevronForwardIcon;
